import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser'; // Importar Title y Meta Services

@Component({
  selector: 'app-jumbotron',
  templateUrl: './jumbotron.component.html',
  styleUrls: ['./jumbotron.component.scss']
})
export class JumbotronComponent implements OnInit {

  constructor(
    private titleService: Title, // Inyección de Title
    private metaService: Meta     // Inyección de Meta
  ) { }

  ngOnInit(): void {
    this.setPageSeo(); // Ejecutar la función para actualizar los metadatos
  }

  // Función que actualiza dinámicamente el <head>
  setPageSeo(): void {
    // 1. Meta Título (<title>)
    this.titleService.setTitle('Uniformes Oficiales Conquistadores y Guías Mayores | CAMBEN');

    // 2. Meta Descripción (<meta name="description">)
    this.metaService.updateTag({ 
      name: 'description', 
      content: 'Encuentra todos los uniformes y accesorios reglamentarios para clubes de Conquistadores, Aventureros y Guías Mayores. Envío rápido y calidad oficial. ¡Compra en CAMBEN!' 
    });

    // 3. Open Graph Tags (para la visualización en IA y Redes Sociales)
    // Nota: El 'og:title' y 'og:description' deben ser similares al SEO principal
    this.metaService.updateTag({ 
      property: 'og:title', 
      content: 'Uniformes Oficiales Conquistadores y Guías Mayores | CAMBEN' 
    });
    this.metaService.updateTag({ 
      property: 'og:description', 
      content: 'Encuentra todos los uniformes y accesorios reglamentarios para clubes de Conquistadores, Aventureros y Guías Mayores. Envío rápido y calidad oficial. ¡Compra en CAMBEN!' 
    });
    this.metaService.updateTag({ 
      property: 'og:url', 
      content: 'https://tudominio.com/TiendaClubAdventista' 
    });
    // Se recomienda también agregar la URL de una imagen destacada 'og:image'
  }

}